import { singleApiReducer } from './single-api-reducer';
import API from '../../API';

export const useTask = singleApiReducer(API.tasks.get);
